import React from 'react';
import styled from 'styled-components';
import Colors from '../common/Color';
import Images from '../common/Images';

function Home() {

  const MoreButton = (e) => {
    const location = document.querySelector('#aboutMe').offsetTop;
    window.scrollTo({top : location - 67, behavior : 'smooth'});
  };

  return (
    <>
      <Container>
      <Image src={Images.profile} />
        <Wrapper>
          <Section>
            <TextList>
              <InfoTitle>문제가 생기면 더 집요해지는</InfoTitle>
              <InfoTitle>
                개발자 <text style={{color : Colors.button}}>박선민</text>입니다.
              </InfoTitle>
              <Info style={{marginTop : '9%',}}>
              해결되지 않는 문제는 없다고 생각합니다.
              </Info>
              <Info style={{marginTop : '5%',}}>
              프론트엔드와 백엔드, 새로운 기술을 넘나들며 실제로 동작하는 서비스를 만드는 데 집중해왔고
              </Info>
              <Info>
              팀원들과의 소통을 통해 서비스 구조를 개선하고 완성도를 높여온 개발자입니다.

              </Info>
              
            </TextList>
          </Section>
          <Section>
            <Button onClick={MoreButton}>MORE</Button>
          </Section>
        </Wrapper>
      </Container>
    </>
  );
}

const Container = styled.div`
  width : 100%;
  box-sizing : border-box;
  img {
    width : 100%;
    height : 700px;
    object-fit : cover;
  }
`;
const Image = styled.img`
  width : 100%;
  opacity : 0.5;
`;
const Wrapper = styled.div`
  width : 90%;
  margin : 0 3%;
  position : absolute;
  top : 15%;
  left : 5%;
  @media screen and (max-width : 500px) {
    left : 0;
  }
`;
const Section = styled.div`
  width : 45%;
  border-radius : 2rem;
  @media screen and (max-width : 1000px) {
    width : 55%;
  }
  @media screen and (max-width : 768px) {
    width : 70%;
  }
  @media screen and (max-width : 500px) {
    width : 100%;
  }
`;
const TextList = styled.div`
  width : 100%;
  padding : 6%;
`;
const InfoTitle = styled.div`
  margin-bottom : 3%;
  font-size : 2.2rem;
  font-weight : 600;
  font-family : 'NotoSans';
  color : ${Colors.white};
  @media screen and (max-width : 1000px) {
    font-size : 1.8rem;
  }
  @media screen and (max-width : 500px) {
    font-size : 1.3rem;
  }
`;
const Info = styled.div`
  margin-top : 2%;
  font-size : 1.2rem;
  font-weight : 300;
  font-family : 'NotoSans';
  color : ${Colors.white};
  line-height: 1.6;
  @media screen and (max-width : 1000px) {
    font-size : 1rem;
  }
  @media screen and (max-width : 500px) {
    font-size : 0.9rem;
  }
`;
const Button = styled.div`
  width : 20%;
  margin: 30px 5%;
  
  padding : 2.2% 0;
  border-radius : 2rem;
  background-color : ${Colors.button};
  text-align : center;
  font-size : 1.2rem;
  font-weight : 700;
  font-family : 'BalooChettan';
  &:hover {
    background-color : ${Colors.button};
  };
  cursor : pointer;
  @media screen and (max-width : 1000px) {
    font-size : 1rem;
    padding : 3% 2%;
  }
  @media screen and (max-width : 768px) {
    font-size : 0.95rem;
  }
`;

export default Home;
